import { NextSeo } from 'next-seo';
import { useEffect, useRef, useState } from 'react';
import { getSeoVisibility } from '../../appconfig';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import InstallNudge from '../../../src/components/QnaPage/InstallNudge/InstallNudge';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import { getDeviceType } from '../../../src/Utils/helper';
import { googlePlayStoreLink } from '../../Constants/branchUrls';
import ParentingGeneralItems from './ParentingGeneralItems';
import { fireViewedGeneralScreenEvent } from '../../Utils/useFirebase';

export default function ParentingEnglish(props) {
  const {
    parentingPageData,
    questionData,
    recentlyAskedQues,
    language,
    categoryData,
  } = props;
  const installLink = googlePlayStoreLink;
  const [showInstallStrip, setShowInstallStrip] = useState(true);
  const deviceType = useRef();
  const metaTitle = 'India’s Most Trusted Parenting Brand | MyloFamily';
  const metaDescription =
    'Parenting is both challenging & rewarding. Discover more about parenting tips for kids at every stage of their lives, positive parenting, safety, & health @MyloFamily';
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    url: `https://mylofamily.com/parenting`,
    images: [
      {
        url: 'https://mylofamily.com/v2/static/images/512mylo.png',
        width: 512,
        height: 512,
      },
    ],
  };
  const Footnotes = parentingPageData?.data?.items?.filter(function (item) {
    return item?.itemType === 'SEO_FOOTNOTE';
  });
  const { heading, htmlText } =
    Footnotes && Footnotes.length > 0 ? Footnotes?.[0] : '';

  useEffect(() => {
    fireViewedGeneralScreenEvent();
    deviceType.current = getDeviceType();
  }, []);

  const closeInstallStrip = () => {
    fireEvent({
      category: 'discard_strip',
      screen_name: getScreenName(),
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
      parent: 'Install App Nudge Strip Mobile',
    });
    setShowInstallStrip(false);
  };

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
          />
        </>
      ) : null}
      <GlobalStyle />
      <div>
        <NewHeader
          showCart={true}
          showTrackOrder={true}
          categoryData={categoryData}
          nostrip={true}
        />
        {showInstallStrip ? (
          <InstallNudge
            installLink={installLink}
            closeInstallStrip={closeInstallStrip}
            appIsPreasent={false}
          />
        ) : null}
        <ParentingGeneralItems
          parentingPageData={parentingPageData}
          isStagePage={false}
          recentlyAskedQues={recentlyAskedQues}
          questionData={questionData}
        />
      </div>
      <NewFooter heading={heading} content={htmlText} />
    </>
  );
}
